import { render, staticRenderFns } from "./BitesDuplicateModal.vue?vue&type=template&id=afed2c56&scoped=true"
import script from "./BitesDuplicateModal.vue?vue&type=script&lang=js"
export * from "./BitesDuplicateModal.vue?vue&type=script&lang=js"
import style0 from "./BitesDuplicateModal.vue?vue&type=style&index=0&id=afed2c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afed2c56",
  null
  
)

export default component.exports